import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Brush,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { IChartProps, StickyTooltip } from '../../../../../component/charts';
import ChartCard from '../../../../../component/charts/chartCard';
import {
  labelFormatterNumber,
  labelFormatterPercentile,
} from '../../../../../shared/formatters/formatters';
import { ReleasesVersusIPCAChartData } from './types';

export const ReleasesVersusIPCA: React.FC = () => {
  const { requesStatusMarketCycle, chartsDataMarketCycle } = useSelector(
    (state: any) => state.marketCycleState
  );

  return (
    <ChartCard
      data={chartsDataMarketCycle['releasesVersusIPCA']}
      Chart={ReleasesVersusIPCAChart}
      cy={'ReleasesVersusIPCA'}
      id={'releasesVersusIPCA'}
      requestStatus={requesStatusMarketCycle['releasesVersusIPCA']}
    />
  );
};

const ReleasesVersusIPCAChart: React.FC<
  IChartProps<ReleasesVersusIPCAChartData[]>
> = ({ data, cy, id }) => {
  const { preference } = useSelector((state: any) => state.layoutState);
  const nls = require(`../../nls/${preference.language.id}.json`);
  const [hasClicked, setHasClicked] = useState<boolean>(false);
  const [recordTooltip, setRecordTooltip] = useState<JSX.Element | null>(null);
  const [stopChange, setStopChange] = useState<boolean>(false);
  const formatterFunctions = [labelFormatterNumber, labelFormatterPercentile];
  const dispatch = useDispatch();
  const getKeys = (chartData: any): { inflation: string; period: string } => {
    try {
      switch (chartData[0].type) {
        case 'month':
          return { inflation: 'in_month', period: 'month' };
        case 'year':
          return { inflation: 'in_year', period: 'year' };
        case 'quarter':
          return { inflation: 'in_quarter', period: 'quarter' };
        default:
          return { inflation: '', period: '' };
      }
    } catch (e) {
      return { inflation: '', period: '' };
    }
  };
  const { inflation, period } = getKeys(data);
  return data ? (
    <ResponsiveContainer data-cy={`ReleasesVersusIPCA${cy}`}>
      <LineChart
        id={id}
        data={data}
        margin={{
          top: 30,
          right: 30,
          left: 20,
          bottom: 5,
        }}
        onClick={() => setHasClicked(!hasClicked)}
      >
        <XAxis
          dataKey="period"
          padding={{ left: 30, right: 30 }}
          domain={['auto', 'dataMax']}
        />
        <YAxis
          yAxisId="absolute"
          orientation="left"
          label={{
            value: nls.charts.releasesVersusIPCA.releases,
            position: 'top',
            offset: 15,
          }}
          tickFormatter={(value: number) => labelFormatterNumber(value)}
        ></YAxis>
        <YAxis
          yAxisId="percentile"
          orientation="right"
          label={{
            value: nls.charts.releasesVersusIPCA.ipca,
            position: 'top',
            offset: 15,
          }}
          unit="%"
        ></YAxis>
        <Legend iconType="circle" />
        <Tooltip
          wrapperStyle={{ visibility: 'visible' }}
          content={
            <StickyTooltip
              hasClicked={hasClicked}
              recordTooltip={recordTooltip}
              setRecordTooltip={setRecordTooltip}
              stopChange={stopChange}
              setStopChange={setStopChange}
              formatterFunctions={formatterFunctions}
            />
          }
        />
        <Line
          yAxisId="absolute"
          type="monotone"
          isAnimationActive={false}
          name={nls.charts.releasesVersusIPCA.releases}
          dataKey="unidades_lancadas"
          stroke="#BA96D9"
        ></Line>
        <Line
          yAxisId="percentile"
          type="monotone"
          isAnimationActive={false}
          name={nls.charts.releasesVersusIPCA.inflation}
          dataKey={inflation}
          stroke="#3F205A"
        ></Line>
        <Brush dataKey="id" height={30} stroke="#8884d8" />
      </LineChart>
    </ResponsiveContainer>
  ) : (
    <></>
  );
};
